module.exports = __webpack_public_path__ + "static/media/land-xs.a091aba6.jpg";